import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogData } from '@rspl-ui';

@Component({
  selector: 'app-download-app-warning-dialog',
  templateUrl: './download-app-warning-dialog.component.html',
  styleUrls: ['./download-app-warning-dialog.component.scss'],
})
export class DownloadAppWarningDialogComponent {

  public constructor(
    public reference: MatDialogRef<DownloadAppWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public dismiss(): void {
    this.reference.close();
  }
}
